import { ListPageSkeleton } from '@practium/ui';

export const LandingPageSkeleton = () => (
	<ListPageSkeleton
		tabsCount={2}
		headerActionsCount={1}
		sidebarWidth="28rem"
		sidebarW1500="22rem"
		sidebarW1300="19rem"
		sidebarW1200="17rem"
		sidebarCardsCount={1}
	/>
);
